"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import BadgeEntryVerificationList from "./BadgeEntryVerificationList"
import BadgeEntryVerificationModal from "./BadgeEntryVerificationModal"
import type { BadgeEntryVerification } from "./types"

const BadgeEntryVerificationContainer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedVerification, setSelectedVerification] = useState<BadgeEntryVerification | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenDetails = (verification: BadgeEntryVerification) => {
    setSelectedVerification(verification)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedVerification(null)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Badge Entries Verifications" parent="Access Control" />
      <Container fluid>
        <Row>
          <Col md="12">
            <BadgeEntryVerificationList onViewDetails={handleOpenDetails} refreshTrigger={refreshTrigger} />
          </Col>
        </Row>

        <BadgeEntryVerificationModal isOpen={modalOpen} toggle={handleCloseModal} verificationData={selectedVerification} />
      </Container>
    </>
  )
}

export default BadgeEntryVerificationContainer
